import React from "react";
import { Box, Container, Stack } from "./Home.styles";
import { Button } from "@hangar/web-components/core/Button";
import { useTheme } from "styled-components";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/auth";
import { useTranslation } from "../../hooks/i18n";
import { Text } from "@hangar/web-components/core/Text";
import { CommunicationStar } from "@hangar/react-icons/core/latam/Communication/CommunicationStar";
import { SecurityProtection } from "@hangar/react-icons/core/latam/Security/SecurityProtection";
import { OperatorLA } from "@hangar/react-icons/core/operator/OperatorLA";
import { HumanUser } from "@hangar/react-icons/core/latam/Human/HumanUser";
import { SparklesFilled } from "@hangar/react-icons/core/interaction/SparklesFilled";

export const Home: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, userProfile } = useAuth();
  const { t } = useTranslation();
  const {
    tokens: { color },
  } = useTheme();

  const features = [
    {
      icon: <SecurityProtection color={color.icon.info} size={40} />,
      title: t("home.features.auth.title"),
      description: t("home.features.auth.description"),
    },
    {
      icon: <CommunicationStar color={color.icon.info} size={40} />,
      title: t("home.features.starter.title"),
      description: t("home.features.starter.description"),
    },
    {
      icon: <OperatorLA size={40} />,
      title: t("home.features.design.title"),
      description: t("home.features.design.description"),
    },
  ];

  return (
    <Container>
      <Box>
        {/* Hero Section */}
        <Box>
          <Text variant="heading-lg" align="center">
            {t("home.title")}
          </Text>

          {isAuthenticated ? (
            <Box>
              <Text variant="heading-xs" align="center">
                {t("home.welcome", { 
                  name: userProfile?.givenName || userProfile?.name || userProfile?.email || "Usuario" 
                })}
              </Text>
              <Stack>
                <Button
                  id="theme-demo-button"
                  size="normal"
                  variant="primary"
                  startIcon={SparklesFilled}
                  label={t("home.actions.viewThemeDemo")}
                  onClick={() => navigate("/theme")}
                />
              </Stack>
            </Box>
          ) : (
            <Box>
              <Stack>
                <Button
                  id="login-button"
                  size="normal"
                  variant="primary"
                  onClick={() => navigate("/login")}
                  startIcon={HumanUser}
                  label={t("home.actions.login")}
                />
              </Stack>
            </Box>
          )}
        </Box>
      </Box>
    </Container>
  );
};
